/**
 * Comments plan 3b: @mentions. A mention is "@Full Name" in the text of someone picked from the list; only picked people
 * whose name is still in the text count (the server keeps only those who may open the page).
 */

/** The text after an "@" right before the caret (what to look for), or null when the caret is not in a mention. */
export function mentionQuery(text, caret) {
  const before = text.slice(0, caret);
  const at = before.lastIndexOf('@');
  if (at === -1 || (at > 0 && !/\s/.test(before[at - 1]))) return null;
  const query = before.slice(at + 1);
  // Up to four name parts ("Anna Maria von Muster"), then it is just text.
  if (query.length > 40 || /\n/.test(query) || query.split(' ').length > 4) return null;
  return query;
}

/** Replaces the typed "@que" before the caret with "@Full Name ". */
export function insertMention(text, caret, member) {
  const at = text.slice(0, caret).lastIndexOf('@');
  const inserted = `@${member.full_name} `;
  return { text: text.slice(0, at) + inserted + text.slice(caret), caret: at + inserted.length };
}

export function mentionIds(text, picked) {
  return [...new Set(picked.filter((m) => text.includes(`@${m.full_name}`)).map((m) => m.user_id))];
}

/** The people matching a query, by any part of their name. */
export function matchMembers(members, query, max = 6) {
  const q = (query || '').toLowerCase();
  return members.filter((m) => (m.full_name || '').toLowerCase().includes(q)).slice(0, max);
}

/** A post's text in parts, the mentions of the given people marked (for display). */
export function bodyParts(body, people) {
  const names = people.map((p) => `@${p.full_name}`).filter((n) => body.includes(n));
  if (!names.length) return [{ text: body, mention: false }];
  const re = new RegExp(`(${names.map((n) => n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'g');
  return body.split(re).filter(Boolean).map((text) => ({ text, mention: names.includes(text) }));
}
